import React from "react";
import { ConfirmationModal } from "@/components/ui";
import type { FinishedEditDialogState } from "@/hooks/useFinishedEditConfirm";

export const FinishedEditConfirmDialog: React.FC<{
  dialog: FinishedEditDialogState | null;
}> = ({ dialog }) => (
  <ConfirmationModal
    open={dialog !== null}
    onOpenChange={(open) => {
      if (!open) dialog?.onCancel();
    }}
    eyebrow="Finished session"
    title="Change the live form?"
    confirmLabel="Save change"
    variant="primary"
    onConfirm={dialog?.onConfirm}
    onCancel={dialog?.onCancel}
    description={
      dialog && (
        <div className="space-y-3 text-sm">
          {dialog.rows.map((row) => (
            <div key={row.label} data-testid="finished-edit-row">
              <p className="font-medium">{row.label}</p>
              {row.changes.length === 0 ? (
                <p className="text-slate-500">No change to this row.</p>
              ) : (
                row.changes.map((c) => (
                  <p key={c.label}>
                    {c.label}: <span className="line-through">{c.before}</span>{" "}
                    → {c.after}
                  </p>
                ))
              )}
            </div>
          ))}
          <div className="border-t pt-2 text-slate-600 dark:text-slate-300">
            {dialog.form && (
              <>
                <p data-testid="finished-edit-form">
                  Form: {dialog.form.marketplace} {dialog.form.productType}{" "}
                  {dialog.form.stamp} → next copy
                </p>
                <p data-testid="finished-edit-drafts">
                  Drafts on this form: {dialog.form.stamped}. Each is checked
                  for notices.
                </p>
              </>
            )}
            <p>
              Live listings: nothing changes now. Each product picks this up at
              its next publish.
            </p>
          </div>
        </div>
      )
    }
  />
);
